import { configureStore } from '@reduxjs/toolkit';
import { GenericReducer } from './GenericReducer';

export default configureStore({
  reducer: GenericReducer
});
